// check category/archives and hioghtlights chosen category by adding class
//
document.addEventListener("DOMContentLoaded", function () {
    // Get the current category from the URL
    let pathArray = window.location.pathname.split('/');
    let category = pathArray.includes('category') ? pathArray[pathArray.indexOf('category') + 1] : null;
    
    if (category) {
        let formattedCategory = category.replace(/-/g, ' ').toLowerCase();
        
        // Loop through all <p> tags to find matching category name
        document.querySelectorAll("p").forEach(function (paragraph) {
            if (paragraph.textContent.trim().toLowerCase() === formattedCategory) {
                paragraph.closest("div").classList.add("current-category");
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Check for "service-tabs" or "product-tabs" and exit if neither is found
    const tabContainer = document.getElementById("web-design-tabs");
    if (!tabContainer) return;  // Exit if neither is found

    // Get the URL parameter "section"
    const urlParams = new URLSearchParams(window.location.search);
    const section = urlParams.get("section");  // e.g., "tab3"
    if (!section) return; 

    // Select all tabs (list items) and panels within the found container
    const tabs = tabContainer.querySelectorAll("li");
    const panels = tabContainer.querySelectorAll('[role="tabpanel"]');

    tabs.forEach(tab => {
        const tabId = tab.id;  // Get the ID of the list item (e.g., "tab1", "tab11")
        const tabNumber = tabId.replace("tab", "");  // Extract the tab number (e.g., "1", "11")
    
        // Find elements with class "kt-title-item-X" where X is the tab number
        const tabElements = tabContainer.querySelectorAll(`.kt-title-item-${tabNumber}`);
        
        // Find all <a> elements with href="#tabX" and data-tab="X"
        const links = tabContainer.querySelectorAll(`a[href="#${tabId}"][data-tab="${tabNumber}"]`);
    
        // Check if this tab matches the section name from the URL
        if (tabId === section) {
            // Add active class
            tabElements.forEach(tabElement => {
                tabElement.classList.add("kt-tab-title-active");
                tabElement.classList.remove("kt-tab-title-inactive");
            });
    
            // Loop through each matching <a> element to set attributes
            links.forEach(link => {
                link.setAttribute("aria-selected", "true");
                link.setAttribute("tabindex", "0");
            });

            // ❌ Remove any existing id="active-tab"
            const existingActiveTab = document.getElementById("gecko-active-tab");
            if (existingActiveTab) {
                existingActiveTab.removeAttribute("id");
            }

            // ✅ Find the correct active tab under .kt-tabs-content-wrap and assign the ID
            const activeTabsInWrap = document.querySelectorAll(".kt-tabs-content-wrap .kt-tab-title-active");
            if (activeTabsInWrap.length > 0) {
                activeTabsInWrap[0].setAttribute("id", "gecko-active-tab"); // Assign only to the first match
            }
    
             // 🔄 Check if the screen is small (max-width: 768px) and scroll to the div with the active class
            const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
            if (isSmallScreen) {
                const activeDiv = document.querySelector("div.kt-tab-title-active");
                if (activeDiv) {
                     activeDiv.scrollIntoView({ behavior: "instant", block: "start"});
                    // activeDiv.scrollIntoView(alignToTop);
                }
            }
        } else {
            // Add inactive class to non-active tabs
            tabElements.forEach(tabElement => {
                tabElement.classList.add("kt-tab-title-inactive");
                tabElement.classList.remove("kt-tab-title-active");
            });
    
            // Loop through each matching <a> element to set attributes
            links.forEach(link => {
                link.setAttribute("aria-selected", "false");
                link.setAttribute("tabindex", "-1");
            });
        }
    });
// Update panels visibility based on "aria-labelledby"
    panels.forEach(panel => {
        if (panel.getAttribute("aria-labelledby") === section) {
            panel.setAttribute("aria-hidden", "false");
            panel.style.display = "block";
        } else {
            panel.setAttribute("aria-hidden", "true");
            panel.style.display = "none";
        }
    });
});


// ***************************************************
// menu trigger when container clicked on
// ***************************************************
document.addEventListener('click', function (e) {
  // Check if the click happened inside .menu-trigger
  if (e.target.closest('.menu-trigger')) {
    const kadenceButton = document.querySelector('.wp-block-kadence-off-canvas-trigger');

    if (kadenceButton) {
      kadenceButton.click();
    } else {
      console.warn('Kadence button not found on this screen size.');
    }
  }
});
